import React, { Component } from 'react';
import { DashboardLayout } from '../../../layout';
import { DeactivateAccountForm } from '../../Common';
import UserProfileMenu from './partials/UserProfileMenu';

class UserDeactivateAccount extends Component {
    render() {
        return (<DashboardLayout activeClass="UserSetting">
            <section className="dashboard">
                <div className="row">
                    <div className="col-md-12 mb-4">
                        <div className="post-box">
                            <h2 className="mb-0 page-title">Account Setting</h2>
                        </div>
                    </div>
                    <UserProfileMenu />
                    <div className="col-md-9">
                        <div className="post-box p-0">
                            <div className="heading">
                            Deactivate Account
                            </div>
                            <div className="setting-form"> 
                                <div className="row">                                        
                                    <div className="col-md-4 col-lg-5 col-12">
                                        <DeactivateAccountForm />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section> 
        </DashboardLayout>);
    }
}

export default UserDeactivateAccount;